import { cn } from "@/lib/utils/cn";

type TourBeaconProps = {
  className?: string;
};

export function TourBeacon({ className }: TourBeaconProps) {
  return (
    <span
      aria-hidden
      className={cn("pointer-events-none size-2.5 rounded-full bg-primary motion-safe:animate-pulse", className)}
    />
  );
}
